import React, { useState } from 'react';
import {
  Button,
  MenuItem,
  Menu,
  List,
  ListItem,
  ListItemText,
  Collapse,
} from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

function NavLinks({ isMobile = false, handleCloseNavMenu, handleOpenContactModal }) {
  const links = [

        { text: "Informations", href: "/#information" },
        { text: "Théâtre", href: "/#theatre" },
        { text: "Film", href: "/#film" },
        { text: "Télévision", href: "/#television" },

  ];

  // État pour le menu en mode desktop
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  const handleOpenMenu = (event, index) => {
    setAnchorEl(event.currentTarget);
    setOpenMenuIndex(index);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setOpenMenuIndex(null);
  };

  // État pour les sous-menus en mode mobile
  const [mobileOpenIndexes, setMobileOpenIndexes] = useState({});

  const handleMobileToggle = (index) => {
    setMobileOpenIndexes((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  if (isMobile) {
    return (
      <List component="nav">
        {links.map((link, index) => (
          <div key={link.text}>
            <ListItem
              button
              onClick={() => {
                if (link.submenu) {
                  handleMobileToggle(index);
                } else if (link.action === 'openContactModal') {
                  handleCloseNavMenu();
                  handleOpenContactModal();
                } else {
                  // Redirection
                  handleCloseNavMenu();
                  window.location.href = link.href;
                }
              }}
              sx={{
                fontFamily: 'Josefin Sans',
                fontWeight: 'bold',
                background: 'radial-gradient(circle farthest-corner at center, rgba(240, 197, 40, 1) 25%, rgba(193, 171, 26, 1) 50%, rgba(180, 136, 14, 1) 75%, rgba(136, 108, 6, 1) 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              <ListItemText
                primary={link.text}
                primaryTypographyProps={{
                  sx: {
                    fontFamily: 'Josefin Sans',
                    fontWeight: 'bold',
                    background: 'radial-gradient(circle farthest-corner at center, rgba(240, 197, 40, 1) 25%, rgba(193, 171, 26, 1) 50%, rgba(180, 136, 14, 1) 75%, rgba(136, 108, 6, 1) 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }
                }}
              />
              {link.submenu ? (
                mobileOpenIndexes[index] ? (
                  <ExpandLess
                    sx={{
                      background: 'radial-gradient(circle farthest-corner at center, rgba(240, 197, 40, 1) 25%, rgba(193, 171, 26, 1) 50%, rgba(180, 136, 14, 1) 75%, rgba(136, 108, 6, 1) 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    }}
                  />
                ) : (
                  <ExpandMore
                    sx={{
                      background: 'radial-gradient(circle farthest-corner at center, rgba(240, 197, 40, 1) 25%, rgba(193, 171, 26, 1) 50%, rgba(180, 136, 14, 1) 75%, rgba(136, 108, 6, 1) 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    }}
                  />
                )
              ) : null}
            </ListItem>
            {link.submenu && (
              <Collapse in={mobileOpenIndexes[index]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {link.submenu.map((sublink) => (
                    <ListItem
                      button
                      key={sublink.text}
                      sx={{ pl: 4 }}
                      onClick={() => {
                        handleCloseNavMenu();
                        window.location.href = sublink.href;
                      }}
                    >
                      <ListItemText
                        primary={sublink.text}
                        primaryTypographyProps={{
                          sx: {
                            fontFamily: 'Josefin Sans',
                            fontWeight: 'bold',
                            background: 'radial-gradient(circle farthest-corner at center, rgba(240, 197, 40, 1) 25%, rgba(193, 171, 26, 1) 50%, rgba(180, 136, 14, 1) 75%, rgba(136, 108, 6, 1) 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                          }
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            )}
          </div>
        ))}
      </List>
    );
  } else {
    return (
      <div style={{ display: 'flex', height: '100%' }}>
        {links.map((link, index) => (
          <div key={link.text}>
            {link.submenu ? (
              <>
                <Button
                  color="inherit"
                  onClick={(e) => handleOpenMenu(e, index)}
                  sx={{
                    height: '100%',
                    borderRadius: 0,
                    borderBottom: '4px solid transparent',
                    '&:hover': {
                      borderBottom: '4px solid currentColor',
                    },
                    display: 'flex',
                    alignItems: 'center',
                    fontFamily: "Josefin Sans",
                    fontWeight: "bold",
                  }}
                >
                  {link.text}
                  <ExpandMore sx={{ ml: 0.5 }} />
                </Button>
                <Menu
                  anchorEl={anchorEl}
                  open={openMenuIndex === index}
                  onClose={handleCloseMenu}
                  disableScrollLock={true}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  {link.submenu.map((sublink) => (
                    <MenuItem
                      key={sublink.text}
                      component="a"
                      href={sublink.href}
                      onClick={handleCloseMenu}
                    >
                      {sublink.text}
                    </MenuItem>
                  ))}
                </Menu>
              </>
            ) : link.action === 'openContactModal' ? (
              <Button
                color="inherit"
                onClick={handleOpenContactModal}
                sx={{
                  height: '100%',
                  borderRadius: 0,
                  borderBottom: '4px solid transparent',
                  '&:hover': {
                    borderBottom: '4px solid currentColor',
                  },
                  fontFamily: "Josefin Sans",
                  fontWeight: "bold",
                }}
              >
                {link.text}
              </Button>
            ) : (
              <Button
                color="inherit"
                href={link.href}
                sx={{
                  height: '100%',
                  borderRadius: 0,
                  borderBottom: '4px solid transparent',
                  '&:hover': {
                    borderBottom: '4px solid currentColor',
                  },
                  fontFamily: "Josefin Sans",
                  fontWeight: "bold",
                }}
              >
                {link.text}
              </Button>
            )}
          </div>
        ))}
      </div>
    );
  }
}

export default NavLinks;
